"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_merge_1 = __importDefault(require("lodash.merge"));
var const_1 = require("../const");
var prosemirror_state_1 = require("prosemirror-state");
var defaultInsertOption = {
    index: 0,
    scrollIntoView: true,
    focus: true,
    replaceEmpty: true,
    deleteSelection: true,
    inheritMarks: true
};
var getOption = function (defaultOption) { return function (param, curIndex) {
    var option = __assign(__assign({}, defaultOption), { index: curIndex });
    if (typeof param === 'number') {
        option.index = param;
    }
    else if (param instanceof Object) {
        Object.assign(option, param);
    }
    return option;
}; };
var getInsertOption = getOption(defaultInsertOption);
var getNodeType = function (view, nodeName) {
    var node = view.state.schema.nodes[nodeName];
    if (!node) {
        console.error("Not found " + nodeName + " in schema!");
        return false;
    }
    if (nodeName === 'text') {
        return {
            name: 'text',
            create: function (attrs, content, marks) { return view.state.schema.text(content, marks); }
        };
    }
    return node;
};
var getMarkType = function (view, markName) {
    var mark = view.state.schema.marks[markName];
    if (!mark) {
        console.error("Not found " + markName + " in schema!");
        return false;
    }
    return mark;
};
var createMark = function (mark, attrs) { return mark.create(attrs); };
var createNode = function (node, attrs, content, marks) { return node.create(attrs, content, marks); };
var collector = function (data, fn) {
    var collectList = [];
    if (!data)
        return collectList;
    if (typeof data === 'string')
        return data;
    data.reduce(function (result) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var res = fn.apply(void 0, args);
        if (res)
            result.push(res);
        return result;
    }, collectList);
    return collectList;
};
// 生成mark处理
var generateMark = function (view, mark) {
    var markInfo = typeof mark === 'string' ? { type: mark } : mark;
    var markType = getMarkType(view, markInfo.type);
    if (!markType)
        return;
    return createMark(markType, markInfo.attrs);
};
// 生成node的处理
var generateNode = function (view, topNodeInfo) {
    var nodeInfo = typeof topNodeInfo === 'string' ? { type: topNodeInfo } : topNodeInfo;
    var marks = nodeInfo.marks, type = nodeInfo.type, attrs = nodeInfo.attrs, content = nodeInfo.content;
    var topNodeType = getNodeType(view, type);
    if (!topNodeType)
        return;
    var contentMarks = collector(marks, function (_markInfo) {
        return generateMark(view, _markInfo);
    });
    var contentNodes = collector(content, function (_nodeInfo) {
        return generateNode(view, _nodeInfo);
    });
    return createNode(topNodeType, attrs, contentNodes, contentMarks);
};
/**
 * insert
 */
var insert = function (view, nodeInfo, index) {
    var state = view.state, dispatch = view.dispatch;
    var userConfig = getInsertOption(index, state.selection.from);
    var pos = userConfig.index, scrollIntoView = userConfig.scrollIntoView, deleteSelection = userConfig.deleteSelection;
    var $from = state.doc.resolve(pos);
    var newNode = generateNode(view, nodeInfo);
    if (!newNode)
        return;
    var tr = state.tr;
    if (deleteSelection && pos === state.selection.from) {
        tr.deleteSelection();
    }
    var isInlineCard = newNode.type.isInline;
    if (isInlineCard && userConfig.inheritMarks) {
        var curMarks = view.state.storedMarks || [];
        if (!curMarks.length)
            curMarks = $from.marks();
        if (curMarks.length) {
            curMarks.push.apply(curMarks, newNode.marks);
            newNode.marks = curMarks;
        }
    }
    if (state.doc.resolve(pos).depth >= 2) {
        // 行内元素直接插入
        if (isInlineCard) {
            tr.insert(pos, newNode);
        }
        else {
            var $pos = tr.doc.resolve(pos);
            var depth = $pos.depth;
            // 找到能够插入块级元素的父元素，避免插入后撕裂节点
            while (depth >= 0) {
                var higherNode = $pos.node(depth);
                if (higherNode.canReplaceWith(higherNode.childCount, higherNode.childCount, newNode.type) ||
                    higherNode.type.name === const_1.NODE_NAME.DOC) {
                    tr.insert($pos.after(depth + 1), newNode);
                    break;
                }
                depth--;
            }
        }
    }
    else if (!isInlineCard && $from.depth && userConfig.replaceEmpty && !$from.parent.childCount) {
        var startPos = $from.before();
        tr.replaceWith(startPos, $from.after(), newNode);
        var $pos = tr.doc.resolve(tr.selection.$to.depth ? tr.selection.$to.after() : tr.selection.to);
        if (tr.selection.from === startPos && (!$pos.nodeAfter || $pos.nodeAfter.isTextblock)) {
            tr.setSelection(prosemirror_state_1.TextSelection.create(tr.doc, $pos.pos));
        }
    }
    else {
        tr.insert(pos, newNode);
        if (state.selection instanceof prosemirror_state_1.NodeSelection && pos === state.selection.from && newNode.isLeaf && !newNode.isText) {
            tr.setSelection(prosemirror_state_1.NodeSelection.create(tr.doc, pos));
        }
    }
    dispatch(scrollIntoView ? tr.scrollIntoView() : tr);
    userConfig.focus && view.focus();
};
exports.insert = insert;
var insertText = function (view, text, format, index) {
    if (format === void 0) { format = {}; }
    var marks = [];
    var topNodeInfo = null;
    Object.keys(format).forEach(function (type) {
        if (getNodeType(view, type))
            topNodeInfo = { type: type, attrs: format[type] };
        else if (getMarkType(view, type))
            marks.push({ type: type, attrs: format[type] });
    });
    var textNodeInfo = { type: 'text', content: text, marks: marks };
    if (!topNodeInfo) {
        return insert(view, textNodeInfo, index);
    }
    else {
        return insert(view, Object.assign(topNodeInfo, { content: [textNodeInfo] }));
    }
};
exports.insertText = insertText;
var defaultReplaceOption = {
    index: 0,
    length: -1,
    scrollIntoView: true,
    inheritMarks: true,
    focus: true
};
var getReplaceOption = getOption(defaultReplaceOption);
var replace = function (view, nodeInfo, replaceOption) {
    var config = getReplaceOption(replaceOption, view.state.selection.from);
    var _a = view.state.selection, $from = _a.$from, $to = _a.$to;
    var newNode = generateNode(view, nodeInfo);
    if (!newNode)
        return;
    if (config.inheritMarks)
        newNode.marks = $from.marksAcross($to) || [];
    var index = config.index, scrollIntoView = config.scrollIntoView, focus = config.focus;
    var length = config.length;
    if (length < 0)
        length = $to.pos - $from.pos;
    var state = view.state, dispatch = view.dispatch;
    var tr = state.tr.replaceWith(index, index + length, newNode);
    dispatch(scrollIntoView ? tr.scrollIntoView() : tr);
    focus && view.focus();
};
exports.replace = replace;
var defaultUpdateOption = {
    index: 0,
    scrollIntoView: false,
    focus: false,
    addToHistory: true,
    merge: true
};
var getUpdateOption = getOption(defaultUpdateOption);
var update = function (view, attrs, updateOption) {
    var state = view.state, dispatch = view.dispatch;
    var _a = getUpdateOption(updateOption, state.selection.from), index = _a.index, scrollIntoView = _a.scrollIntoView, focus = _a.focus, addToHistory = _a.addToHistory, merge = _a.merge;
    var tr = state.tr;
    var curNode = state.doc.nodeAt(index);
    if (!curNode)
        return false;
    if (!Object.keys(attrs).some(function (key) { return key in curNode.attrs; }))
        return;
    var handle = merge ? lodash_merge_1.default : Object.assign;
    tr = tr.setNodeMarkup(index, undefined, handle({}, curNode.attrs, attrs));
    if (!addToHistory)
        tr = tr.setMeta('addToHistory', false);
    dispatch(scrollIntoView ? tr.scrollIntoView() : tr);
    focus && view.focus();
};
exports.update = update;
var defaultDeleteOption = {
    index: 0,
    length: 1,
    scrollIntoView: true,
    focus: true
};
var getDeleteOption = getOption(defaultDeleteOption);
var _delete = function (view, deleteOption) {
    var selection = view.state.selection;
    var _a = getDeleteOption(deleteOption, selection.from), index = _a.index, length = _a.length, scrollIntoView = _a.scrollIntoView, focus = _a.focus;
    var from = index === 0 || index ? index : selection.from;
    var to = length === 0 || length ? from + length : selection.to;
    var state = view.state, dispatch = view.dispatch;
    var tr = state.tr.delete(from, to);
    dispatch(scrollIntoView ? tr.scrollIntoView() : tr);
    focus && view.focus();
};
exports._delete = _delete;
//# sourceMappingURL=state.js.map